// extracted by mini-css-extract-plugin
export default {"container":"TemplateUsers_container__WI0ae","label":"TemplateUsers_label__rfS-h","icon":"TemplateUsers_icon__j8hM0"};